<template>
  <v-chart :option="options" :init-options="{renderer: 'svg'}" autoresize :style="`width: ${width}px; height: ${height}px; font-size: ${fontSize}px;`"/>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import { graphic } from 'echarts/core'
import 'zrender/lib/svg/svg'

export default {
  data () {
    return {}
  },
  computed: {
    options () {
      return {
        textStyle: {
          fontFamily: '"Roboto","Helvetica",sans-serif',
          lineHeight: 1.2381,
          fontWeight: 400
        },
        series: [{
          type: 'pie',
          silent: true,
          radius: ['60%', '80%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            fontSize: 22,
            position: 'center',
            color: this.color
          },
          data: [
            {
              value: this.value,
              name: this.value >= 50 ? `${Math.round(this.value)}` : '',
              itemStyle: {
                // color: this.color
                color: new graphic.LinearGradient(0, 3, 0, 0, [
                  { offset: 0, color: 'white' },
                  { offset: 1, color: this.color }
                ])
              }
            },
            {
              value: 100 - this.value,
              name: this.value < 50 ? `${Math.round(this.value)}` : '',
              itemStyle: {
                color: 'lightgray'
              }
            }
          ]
        }]
      }
    }
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: false,
      default: function () {
        return 100
      }
    },
    height: {
      type: Number,
      required: false,
      default: function () {
        return 100
      }
    },
    fontSize: {
      type: Number,
      required: false,
      default: function () {
        return 22
      }
    }
  },
  components: {
    'v-chart': ECharts
  }
}
</script>
